import { Card, Col, Form, Input, notification, Row } from "antd";
import React, { useEffect, useState } from "react";
import Service from "../../services/request";
import BasicButtonPrimary from "components/BasicButtonPrimary";
import { useTranslation } from "react-i18next";
export default function TorichatSetting({ merchantCode }) {
  const { t: translation } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const getData = () => {
    if (!merchantCode) {
      return;
    }
    setLoading(true);
    Service.send({
      method: "POST",
      path: "/MerchantWorkflow/searchWorkflowAgentByMerchant",
      data: {
        merchantCode: merchantCode,
      },
      newUrl: process.env.REACT_APP_API_TORICHAT_URL,
    })
      .then((res) => {
        if (res) {
          const { statusCode, message, data } = res;
          if (statusCode === 200) {
            setData(data);
            const values = data.reduce((acc, cur, index) => {
              acc[`field_${index}`] = cur.value;
              return acc;
            }, {});
            form.setFieldsValue(values);
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, [merchantCode]);

  return (
    <div >
      <h5>{`Cài đặt trợ lý ảo AI`}</h5>
      <Row>
        <Col xs={24} sm={24} md={19} lg={12}>
          <Form
            layout="vertical"
            onFinishFailed={(errorInfo) => {
              setLoading(false);
            }}
            onFinish={(values) => {
              if (loading || !merchantCode) return;
              const result = data.map((item, index) => ({
                ...item,
                value: values[`field_${index}`],
              }));
              setLoading(true);
              Service.send({
                method: "POST",
                path: "/MerchantWorkflow/updateWorkflowAgentByMerchant",
                data: {
                  merchantCode: merchantCode,
                  data: result,
                },
                newUrl: process.env.REACT_APP_API_TORICHAT_URL,
              })
                .then((res) => {
                  if (res) {
                    const { statusCode } = res;
                    if (statusCode === 200) {
                      notification["success"]({
                        message: "",
                        description: translation("updateSuccess"),
                      });
                      getData();
                    } else {
                      notification["error"]({
                        message: "",
                        description: translation("updateFailed"),
                      });
                    }
                  }
                })
                .catch(() => {
                  notification["error"]({
                    message: "",
                    description: translation("updateFailed"),
                  });
                })
                .finally(() => {
                  setLoading(false);
                });
            }}
            form={form}
          >
            {data.map((item, index) => {
              return (
                <Form.Item
                  key={item.code}
                  label={item.title}
                  name={`field_${index}`}
                  rules={[
                    {
                      required: true,
                      message: `Vui lòng nhập "${item.title}"`,
                    },
                  ]}
                >
                  <Input.TextArea autoSize={{ minRows: 1, maxRows: 8 }} />
                </Form.Item>
              );
            })}

            {data.length > 0 && (
              <BasicButtonPrimary
                loading={loading}
                className="mt-2"
                htmlType="submit"
                text={"Cập nhật"}
              />
            )}
          </Form>
        </Col>
      </Row>
    </div>
  );
}
